import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Box, Typography, Autocomplete, TextField } from '@mui/material';
import { LocationEquivalenciesPanel } from '../components/product-equivalencies/LocationEquivalenciesPanel';
import { locationsApi } from '../api/services';
import type { Location } from '../api/config';

export const LocationEquivalenciesPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const locationIdParam = searchParams.get('location_id');

  const { data: locations = [] } = useQuery({
    queryKey: ['locations'],
    queryFn: () => locationsApi.getAllWithoutFilters(),
  });

  const selectedLocation = locations.find(
    (l) => l.id === Number(locationIdParam)
  ) ?? null;

  const handleLocationChange = (_e: React.SyntheticEvent, location: Location | null) => {
    if (location) {
      setSearchParams({ location_id: String(location.id) });
    } else {
      setSearchParams({});
    }
  };

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Location Product Equivalency Assignments
      </Typography>

      <Autocomplete
        options={locations}
        value={selectedLocation}
        onChange={handleLocationChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderInput={(params) => (
          <TextField {...params} label="Location" placeholder="Select a location..." />
        )}
        sx={{ maxWidth: 400, mb: 3 }}
      />

      {selectedLocation ? (
        <LocationEquivalenciesPanel
          locationId={selectedLocation.id}
          locationName={selectedLocation.name}
        />
      ) : (
        <Typography variant="body2" color="textSecondary">
          Select a location to view and edit its equivalency settings.
        </Typography>
      )}
    </Box>
  );
};
